// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.renegotiation-card {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.renegotiation-card .gyramais-btn {
  min-width: 12.5rem;
  padding: 0rem;
}
.renegotiation-card .gyramais-disclaimer {
  font-size: 0.8rem;
  font-style: italic;
  max-width: 30rem;
  display: inline-block;
  margin-top: 0.25rem;
}
.renegotiation-card .down-payment-mobile {
  display: none;
}
@media (max-width: 768px) {
  .renegotiation-card .down-payment-mobile {
    display: block;
    margin-top: 0.5rem;
  }
}
.renegotiation-card .down-payment-disclaimer {
  margin-bottom: 0.4rem;
}
.renegotiation-card .installment-discount-block {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .renegotiation-card .installment-discount-block {
    margin-right: -6px;
    margin-left: -6px;
  }
}
.renegotiation-card .installment-discount-block .down-payment {
  width: 44%;
  margin-left: 2rem;
  display: flex;
  justify-content: flex-end;
}
.renegotiation-card .installment-discount-block .select-installment-count {
  flex-grow: 1;
}
@media (max-width: 768px) {
  .renegotiation-card .installment-discount-block .select-installment-count {
    width: 100%;
  }
  .renegotiation-card .installment-discount-block .select-installment-count .ant-select-selector {
    padding: 0px 24px 0px 16px !important;
  }
  .renegotiation-card .installment-discount-block .down-payment {
    display: none;
  }
}
.renegotiation-card .title-discount-value {
  white-space: nowrap;
}
.renegotiation-card .text-card {
  border-radius: 0 1.25rem 1.25rem 0;
  border: 1px solid #c9d3cc;
  border-left: 1px dashed var(--primary-color);
  width: 100%;
}
.renegotiation-card .text-card .ant-divider {
  border-color: #c9d3cc;
}
.renegotiation-card .text-card .card-value {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
}
.renegotiation-card .text-card .card-value .card-value-text {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.renegotiation-card .text-card .card-value .card-value-text p {
  margin-bottom: 0.8rem;
}
@media (max-width: 768px) {
  .renegotiation-card .text-card .card-value .card-value-text p {
    margin-bottom: 0.4rem;
  }
}
@media (max-width: 768px) {
  .renegotiation-card .text-card .card-value .card-value-text {
    margin-top: 1rem;
  }
}
.renegotiation-card .text-card .card-value .card-value-text button {
  display: none;
}
.renegotiation-card .text-card .card-value .card-value-text .card-value-text-value {
  display: flex;
  flex-direction: row;
  align-items: end;
  line-height: 1.5rem;
}
@media (max-width: 768px) {
  .renegotiation-card .text-card .card-value .card-value-text .card-value-text-value {
    justify-content: center;
  }
}
.renegotiation-card .text-card .card-value .card-value-text .card-value-text-value .old-value {
  text-decoration-line: line-through;
  color: #e22121;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.5rem;
  margin-right: 0.5rem;
}
.renegotiation-card .text-card .card-value .card-value-text .card-value-text-value .new-value {
  font-size: 3rem;
  line-height: 1.5rem;
  margin-right: 0;
}
.renegotiation-card .text-card .card-value .card-value-buttons {
  display: flex;
  flex-direction: column;
  color: var(--danger-color);
  min-height: 120px;
  font-size: 0.875rem;
  font-weight: 500;
  align-items: flex-end;
  justify-content: space-between;
}
.renegotiation-card .text-card .card-value .card-value-buttons .promotion-card__clock {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0.75rem;
}
.renegotiation-card .text-card .card-value .card-value-buttons .promotion-card__clock .anticon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}
.renegotiation-card .text-card .card-value .card-value-buttons .promotion-card__clock .ant-statistic {
  margin-top: 0.25rem;
  line-height: 120%;
}
.renegotiation-card .text-card .card-value .card-value-buttons .promotion-card__clock .ant-statistic span {
  font-size: 1.5rem;
  line-height: 120%;
  font-weight: 500;
}
.renegotiation-card .text-card button {
  background-color: var(--primary-button-color);
  color: var(--primary-button-text-color);
}
@media (max-width: 768px) {
  .renegotiation-card {
    flex-direction: column;
  }
  .renegotiation-card .ant-select {
    width: 100%;
  }
  .renegotiation-card .text-card {
    border-radius: 0 0 1rem 1rem;
    border-top: 1px dashed var(--primary-color);
    border-left: 1px solid #c9d3cc;
  }
  .renegotiation-card .text-card .card-content {
    font-size: 0.875rem;
  }
  .renegotiation-card .text-card .card-value .card-value-text .new-value {
    font-size: 2rem !important;
  }
  .renegotiation-card .text-card .card-value .card-value-text button {
    display: block;
    margin-top: 0.5rem;
  }
  .renegotiation-card .text-card .card-value .card-value-buttons {
    display: none;
  }
}
.promotion-gyra-select {
  max-width: 30rem;
  width: 100%;
}
.promotion-gyra-select .ant-select-selection-item {
  display: flex;
  padding: 0 !important;
  width: 100%;
  align-items: center;
}
.promotion-gyra-select .ant-select-selection-item .select-value {
  font-weight: 700;
  display: inline-block;
  margin-left: 0.25rem;
  margin-right: 1rem;
}
.promotion-gyra-select .ant-select-selection-item .background-text {
  font-weight: 700;
  border-radius: 1.25rem;
  background: var(--primary-button-color);
  color: var(--primary-button-text-color);
  padding: 0.25rem 0.75rem;
  margin-left: auto;
  margin-right: 1rem;
}
.promotion-gyra-select .ant-select-selection-item .background-text .per-invoice-two-lines {
  display: none;
}
.promotion-gyra-select .ant-select-selection-item .background-text .mobile {
  font-weight: 700;
}
@media (max-width: 768px) {
  .promotion-gyra-select .ant-select-selection-item .background-text .mobile {
    display: none;
  }
}
.promotion-gyra-select-option .ant-select-item-option-content {
  display: flex;
  align-items: center;
}
.promotion-gyra-select-option .ant-select-item-option-content .select-value {
  font-weight: 700;
  display: inline-block;
  margin-left: 0.25rem;
  margin-right: 1rem;
}
.promotion-gyra-select-option .ant-select-item-option-content .background-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  border-radius: 1.25rem;
  background: var(--primary-button-color);
  color: var(--primary-button-text-color);
  padding: 0.25rem 0.75rem;
  margin-left: auto;
  margin-right: 0.5rem;
}
.promotion-gyra-select-option .ant-select-item-option-content .background-text .mobile {
  font-weight: 700;
  margin-left: 3px;
}
.promotion-gyra-select-option .ant-select-item-option-content .background-text .per-invoice-two-lines {
  display: none;
}
@media (max-width: 768px) {
  .promotion-gyra-select-option .ant-select-item-option-content .background-text .per-invoice-two-lines {
    display: inline-block;
    margin-left: 7px;
  }
  .promotion-gyra-select-option .ant-select-item-option-content .background-text .per-invoice-two-lines div {
    line-height: 11px;
    font-size: 9px;
    font-weight: 400;
  }
  .promotion-gyra-select-option .ant-select-item-option-content .background-text .mobile {
    display: none;
  }
  .promotion-gyra-select-option .ant-select-item-option-content .background-text .discount-one-line {
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/PromoRenegotiationScreen/Components/PromoRenegotiationCard.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AAJA;EAMI,kBAAA;EACA,aAAA;AACJ;AARA;EAWI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAAJ;AAfA;EAmBI,aAAA;AADJ;AAGI;EAAA;IACE,cAAA;IACA,kBAAA;EAAJ;AACF;AAxBA;EA4BI,qBAAA;AADJ;AA3BA;EAgCI,aAAA;EACA,mBAAA;AAFJ;AAII;EAAA;IACE,kBAAA;IACA,iBAAA;EADJ;AACF;AArCA;EAyCM,UAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;AADN;AA3CA;EAgDM,YAAA;AAFN;AAKI;EAAA;IAEI,WAAA;EAHN;EACE;IAIM,qCAAA;EAFR;EAFE;IAQI,aAAA;EAHN;AACF;AAzDA;EAiEI,mBAAA;AALJ;AA5DA;EAqEI,kCAAA;EACA,yBAAA;EACA,4CAAA;EACA,WAAA;AANJ;AAlEA;EA2EM,qBAAA;AANN;AArEA;EA+EM,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;AAPN;AA5EA;EAsFQ,aAAA;EACA,sBAAA;EACA,WAAA;AAPR;AAjFA;EA2FU,qBAAA;AAPV;AAQU;EAAA;IACE,qBAAA;EALV;AACF;AAQQ;EAAA;IACE,gBAAA;EALR;AACF;AA9FA;EAsGU,aAAA;AALV;AAjGA;EA0GU,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AANV;AAQU;EAAA;IACE,uBAAA;EALV;AACF;AA5GA;EAoHY,kCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AALZ;AApHA;EA4HY,eAAA;EACA,mBAAA;EACA,eAAA;AALZ;AAzHA;EAoIQ,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8BAAA;AARR;AAnIA;EA8IU,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AARV;AA1IA;EAoJY,iBAAA;EACA,oBAAA;AAPZ;AA9IA;EAwJY,mBAAA;EACA,iBAAA;AAPZ;AAlJA;EA2Jc,iBAAA;EACA,iBAAA;EACA,gBAAA;AANd;AAvJA;EAoKM,6CAAA;EACA,uCAAA;AAVN;AAcE;EAAA;IACE,sBAAA;EAXF;EAUA;IAII,WAAA;EAXJ;EAOA;IAQI,4BAAA;IACA,2CAAA;IACA,8BAAA;EAZJ;EAEA;IAaM,mBAAA;EAZN;EADA;IAmBU,0BAAA;EAfV;EAJA;IAsBU,cAAA;IACA,kBAAA;EAfV;EARA;IA2BQ,aAAA;EAhBR;AACF;AAsBA;EACE,gBAAA;EACA,WAAA;AApBF;AAkBA;EAKI,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AApBJ;AAYA;EAWM,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AApBN;AAMA;EAkBM,gBAAA;EACA,sBAAA;EACA,uCAAA;EACA,uCAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;AArBN;AAHA;EA2BQ,aAAA;AArBR;AANA;EA+BQ,gBAAA;AAtBR;AAyBM;EAAA;IAEI,aAAA;EAvBR;AACF;AA6BA;EAEI,aAAA;EACA,mBAAA;AA5BJ;AAyBA;EAMM,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AA5BN;AAmBA;EAaM,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uCAAA;EACA,uCAAA;EACA,wBAAA;EACA,iBAAA;EACA,oBAAA;AA7BN;AAOA;EAyBQ,gBAAA;EACA,gBAAA;AA7BR;AAGA;EA8BQ,aAAA;AA9BR;AAiCM;EAAA;IAEI,qBAAA;IACA,gBAAA;EA/BR;EA4BI;IAMM,iBAAA;IACA,cAAA;IACA,gBAAA;EA/BV;EAuBI;IAaI,aAAA;EAjCR;EAoBI;IAiBI,qBAAA;IACA,eAAA;IACA,gBAAA;EAlCR;AACF","sourcesContent":[".renegotiation-card {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n\n  .gyramais-btn {\n    min-width: 12.5rem;\n    padding: 0rem;\n  }\n\n  .gyramais-disclaimer {\n    font-size: 0.8rem;\n    font-style: italic;\n    max-width: 30rem;\n    display: inline-block;\n    margin-top: 0.25rem;\n  }\n\n  .down-payment-mobile {\n    display: none;\n\n    @media (max-width: @md-screen) {\n      display: block;\n      margin-top: 0.5rem;\n    }\n  }\n\n  .down-payment-disclaimer {\n    margin-bottom: 0.4rem;\n  }\n\n  .installment-discount-block {\n    display: flex;\n    align-items: center;\n\n    @media (max-width: @md-screen) {\n      margin-right: -6px;\n      margin-left: -6px;\n    }\n\n    .down-payment {\n      width: 44%;\n      margin-left: 2rem;\n      display: flex;\n      justify-content: flex-end;\n    }\n\n    .select-installment-count {\n      flex-grow: 1;\n    }\n\n    @media (max-width: @md-screen) {\n      .select-installment-count {\n        width: 100%;\n        .ant-select-selector {\n          padding: 0px 24px 0px 16px !important;\n        }\n      }\n      .down-payment {\n        display: none;\n      }\n    }\n  }\n\n  .title-discount-value {\n    white-space: nowrap;\n  }\n\n  .text-card {\n    border-radius: 0 1.25rem 1.25rem 0;\n    border: 1px solid #c9d3cc;\n    border-left: 1px dashed var(--primary-color);\n    width: 100%;\n\n    .ant-divider {\n      border-color: #c9d3cc;\n    }\n\n    .card-value {\n      display: flex;\n      flex-direction: row;\n      align-items: flex-end;\n      justify-content: space-between;\n      width: 100%;\n\n      .card-value-text {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n\n        p {\n          margin-bottom: 0.8rem;\n          @media (max-width: @md-screen) {\n            margin-bottom: 0.4rem;\n          }\n        }\n\n        @media (max-width: @md-screen) {\n          margin-top: 1rem;\n        }\n\n        button {\n          display: none;\n        }\n\n        .card-value-text-value {\n          display: flex;\n          flex-direction: row;\n          align-items: end;\n          line-height: 1.5rem;\n\n          @media (max-width: @md-screen) {\n            justify-content: center;\n          }\n\n          .old-value {\n            text-decoration-line: line-through;\n            color: #e22121;\n            font-size: 1rem;\n            font-weight: 300;\n            line-height: 1.5rem;\n            margin-right: 0.5rem;\n          }\n          .new-value {\n            font-size: 3rem;\n            line-height: 1.5rem;\n            margin-right: 0;\n          }\n        }\n      }\n\n      .card-value-buttons {\n        display: flex;\n        flex-direction: column;\n        color: var(--danger-color);\n        min-height: 120px;\n        font-size: 0.875rem;\n        font-weight: 500;\n        align-items: flex-end;\n        justify-content: space-between;\n\n        .promotion-card__clock {\n          display: flex;\n          align-items: center;\n          font-size: 1.5rem;\n          font-weight: 500;\n          margin-bottom: 0.75rem;\n          .anticon {\n            font-size: 1.5rem;\n            margin-right: 0.5rem;\n          }\n          .ant-statistic {\n            margin-top: 0.25rem;\n            line-height: 120%;\n            span {\n              font-size: 1.5rem;\n              line-height: 120%;\n              font-weight: 500;\n            }\n          }\n        }\n      }\n    }\n    button {\n      background-color: var(--primary-button-color);\n      color: var(--primary-button-text-color);\n    }\n  }\n\n  @media (max-width: @md-screen) {\n    flex-direction: column;\n\n    .ant-select {\n      width: 100%;\n    }\n\n    .text-card {\n      border-radius: 0 0 1rem 1rem;\n      border-top: 1px dashed var(--primary-color);\n      border-left: 1px solid #c9d3cc;\n\n      .card-content {\n        font-size: 0.875rem;\n      }\n\n      .card-value {\n        .card-value-text {\n          .new-value {\n            font-size: 2rem !important;\n          }\n          button {\n            display: block;\n            margin-top: 0.5rem;\n          }\n        }\n        .card-value-buttons {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n.promotion-gyra-select {\n  max-width: 30rem;\n  width: 100%;\n\n  .ant-select-selection-item {\n    display: flex;\n    padding: 0 !important;\n    width: 100%;\n    align-items: center;\n\n    .select-value {\n      font-weight: 700;\n      display: inline-block;\n      margin-left: 0.25rem;\n      margin-right: 1rem;\n    }\n\n    .background-text {\n      font-weight: 700;\n      border-radius: 1.25rem;\n      background: var(--primary-button-color);\n      color: var(--primary-button-text-color);\n      padding: 0.25rem 0.75rem;\n      margin-left: auto;\n      margin-right: 1rem;\n\n      .per-invoice-two-lines {\n        display: none;\n      }\n\n      .mobile {\n        font-weight: 700;\n      }\n\n      @media (max-width: @md-screen) {\n        .mobile {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n.promotion-gyra-select-option {\n  .ant-select-item-option-content {\n    display: flex;\n    align-items: center;\n\n    .select-value {\n      font-weight: 700;\n      display: inline-block;\n      margin-left: 0.25rem;\n      margin-right: 1rem;\n    }\n\n    .background-text {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-weight: 700;\n      border-radius: 1.25rem;\n      background: var(--primary-button-color);\n      color: var(--primary-button-text-color);\n      padding: 0.25rem 0.75rem;\n      margin-left: auto;\n      margin-right: 0.5rem;\n\n      .mobile {\n        font-weight: 700;\n        margin-left: 3px;\n      }\n\n      .per-invoice-two-lines {\n        display: none;\n      }\n\n      @media (max-width: @md-screen) {\n        .per-invoice-two-lines {\n          display: inline-block;\n          margin-left: 7px;\n\n          div {\n            line-height: 11px;\n            font-size: 9px;\n            font-weight: 400;\n          }\n        }\n\n        .mobile {\n          display: none;\n        }\n\n        .discount-one-line {\n          display: inline-block;\n          font-size: 12px;\n          font-weight: 400;\n        }\n      }\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
